import type { PushNotificationLinkType } from "@athena/common/graphql/generated/schema";

export type NotificationLink = "none" | "chat" | "course" | "course_step";

const LINK_TYPE_BY_NOTIFICATION_LINK: Record<NotificationLink, PushNotificationLinkType> = {
    none: "NONE",
    chat: "CHAT",
    course: "COURSE",
    course_step: "COURSE_STEP",
};

/** What a sender writes, before choosing who it goes to: the admin portal's and the alumni console's alike. */
export interface PushNotificationDraft {
    internalTitle: string;
    title: string;
    body: string;
    link: NotificationLink;
    courseId?: string;
    contentId?: string;
}

export const EMPTY_DRAFT: PushNotificationDraft = { internalTitle: "", title: "", body: "", link: "none" };

/** A title, a body, and whatever the chosen link needs. */
export const isDraftReady = (draft: PushNotificationDraft): boolean =>
    Boolean(draft.title) &&
    Boolean(draft.body) &&
    !(draft.link === "course" && !draft.courseId) &&
    !(draft.link === "course_step" && !draft.contentId);

/** The draft as either send mutation's input takes it; recipients are the caller's to add. */
export const draftMessage = (draft: PushNotificationDraft) => ({
    privateSubject: draft.internalTitle || undefined,
    subject: draft.title,
    body: draft.body,
    linkType: LINK_TYPE_BY_NOTIFICATION_LINK[draft.link],
    courseId: draft.link === "course" ? draft.courseId : undefined,
    contentId: draft.link === "course_step" ? draft.contentId : undefined,
});
